export { isFunction, once, noop, debounce, defer } from 'lodash-es';
export function invoke(func, args, ctx) {
    let ret;
    if (func != null && typeof func === 'function') {
        const fn = func;
        const len = args.length;
        if (len === 0) {
            ret = fn.call(ctx);
        }
        else if (len === 1) {
            ret = fn.call(ctx, args[0]);
        }
        else if (len === 2) {
            ret = fn.call(ctx, args[0], args[1]);
        }
        else if (len === 3) {
            ret = fn.call(ctx, args[0], args[1], args[2]);
        }
        else if (len === 4) {
            ret = fn.call(ctx, args[0], args[1], args[2], args[3]);
        }
        else if (len === 5) {
            ret = fn.call(ctx, args[0], args[1], args[2], args[3], args[4]);
        }
        else if (len === 6) {
            ret = fn.call(ctx, args[0], args[1], args[2], args[3], args[4], args[5]);
        }
        else {
            ret = fn.apply(ctx, args);
        }
    }
    return ret;
}
export function apply(func, ctx, args = []) {
    return invoke(func, args, ctx);
}
export function call(func, ctx, ...args) {
    return invoke(func, args, ctx);
}
function repush(array, item) {
    for (let i = 0, ii = array.length; i < ii; i += 1) {
        if (array[i] === item) {
            return array.push(array.splice(i, 1)[0]);
        }
    }
}
export function cacher(fn, ctx, postProcessor) {
    const keys = [];
    const cache = {};
    const f = (...args) => {
        let hasCache = false;
        const key = args.join('\u2400');
        if (key in cache) {
            hasCache = true;
            repush(keys, key);
        }
        else {
            if (keys.length >= 1000) {
                delete cache[keys.shift()];
            }
            keys.push(key);
            cache[key] = invoke(fn, args, ctx);
        }
        return postProcessor ? postProcessor(cache[key], hasCache) : cache[key];
    };
    return f;
}
//# sourceMappingURL=function.js.map